"use client";

import { COOKIE_CONSENT_KEY } from "./cookie-consent";

function clearConsentAndReload() {
  document.cookie = `${COOKIE_CONSENT_KEY}=; path=/; max-age=0`;
  window.location.reload();
}

/**
 * Button that clears the cookie consent and reloads so the banner shows again.
 * Use when the user wants to change their cookie preferences.
 */
export function CookiePreferencesLink({
  children = "Cookie preferences",
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={clearConsentAndReload}
      className={className}
    >
      {children}
    </button>
  );
}
